import { z } from 'zod';
import { clipKindSchema } from '../clipKind';

export const vaultQueueJobSchema = z.object({
  id: z.number(),
  clipId: z.number(),
  localPath: z.string(),
  kind: clipKindSchema,
  status: z.string(),
  retryCount: z.number(),
  error: z.string().nullable(),
  sizeKb: z.number().nullish(),
  r2Key: z.string().nullish(),
  createdAt: z.string(),
  startedAt: z.string().nullish(),
  completedAt: z.string().nullish(),
});

export type IVaultQueueJob = z.infer<typeof vaultQueueJobSchema>;

export const fetchQueueResponseSchema = z.array(vaultQueueJobSchema);

export type IFetchQueueResponse = z.infer<typeof fetchQueueResponseSchema>;
